import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CmsserviceService } from '../../../common-cms-service/cmsservice.service';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
declare var $: any;
declare const grecaptcha: any;

const LEGAL_LINKS_DATA = [
  { label: 'Terms & Conditions', path: '/terms-conditions' },
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Payment & Refund', path: '/legal/payment-refund' },
  { label: 'Disclaimers', path: '/legal/disclaimers' },
  { label: 'Copy Right', path: '/legal/copy-right' }
];

const QUICK_LINKS_DATA = [
  { label: 'Home', path: '/' },
  { label: 'Sehyog', path: '/sehyog/inception-story' },
  { label: '11Plus Help Club', path: '/11plus-help-club' },
  { label: 'Category', path: '/11plus-help-club/category' },
  { label: 'Success Stories', path: '/11plus-help-club/get-inspired/success-stories' },
  { label: 'Contact Us', path: '/contact-us' },
  { label: 'Become A Volunteer', path: '/become-a-volunteer' }
];

// TODO: replace with a CMS-driven feed once a blog list endpoint is available (CmsserviceService)
const FEATURED_POSTS_DATA = [
  {
    eyebrow: '11+ Prep',
    title: 'Five Habits That Build 11+ Exam Confidence',
    excerpt: 'Small daily routines that add up before results day.',
    thumb: 'https://picsum.photos/seed/sehyog-blog-1/120/120',
    path: '/blog/five-habits-11-plus-confidence'
  },
  {
    eyebrow: 'GCSE',
    title: 'A Parent\'s Guide to Choosing GCSE Options',
    excerpt: 'What to weigh up before subject choices lock in.',
    thumb: 'https://picsum.photos/seed/sehyog-blog-2/120/120',
    path: '/blog/parents-guide-gcse-options'
  }
];

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy, AfterContentInit {
  pagetitle: string;
  getInTouch: UntypedFormGroup;
  pageslug: string;
  categories = [];
  catDetail = [];
  slug: string;
  formData: any;
  siteSetting: any;
  formMessage = '';
  cookieValue = '';
  ngUnsubscribe = new Subject<void>();
  googleCaptcha: boolean;
  googleKey = environment.liveGoogleCaptcha;
  testPopupCondition: boolean;

  legalLinks = LEGAL_LINKS_DATA;
  quickLinks = QUICK_LINKS_DATA;
  featuredPosts = FEATURED_POSTS_DATA;

  constructor(
    private cmsService: CmsserviceService,
    private router: Router,
    private cookiesService: CookieService,
    private fb: UntypedFormBuilder
  ) {

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        // window.scrollTo(0, 0)
        const slugArr = val.url.split('/');
        const allow = ['contact-us', 'donation', 'support', 'request-for-franchise'];
        if (allow.includes(slugArr[slugArr.length - 1])) {
          this.testPopupCondition = false;
        } else {
          this.testPopupCondition = true;
        }
      }
    });
  }
  ngOnInit() {
    this.cmsService.commonSiteSettingSingleton().subscribe(res => {
      this.siteSetting = res;
    });
    this.CategoryList();
    this.getCookies();
    this.getInTouch = this.fb.group({
      name: ['', Validators.required],
      email_id: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      message: ['', Validators.required],
      recaptcha: [null, Validators.required]
    });
  }

  onBookAssessment() {
    this.router.navigate(['/contact-us']);
  }

   bookFreeDemo() {
    window.open('https://go.sehyog.co.uk/FreeDemoForm', '_blank');
  }

  onSubmit() {
    if (this.getInTouch.get('recaptcha').untouched) {
      $('.error').fadeIn();
      setTimeout(() => {
        $('.error').fadeOut();
      }, 3000);
    } else {

      this.formData = {
        form_type: 'get-in-touch',
        name: this.getInTouch.get('name').value,
        email_id: this.getInTouch.get('email_id').value,
        phone: this.getInTouch.get('phone').value,
        subject: '',
        message: this.getInTouch.get('message').value
      };
      if (this.getInTouch.valid) {
        $('.get-touch').fadeIn();
        this.cmsService.submitFormsService(this.formData)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            $('.get-touch').fadeOut();
            if (res.code === 200) {
              this.formMessage = res.message;
              $('.form-overlay .overlay').fadeIn();
              setTimeout(() => {
                grecaptcha.reset();
                this.googleCaptcha = false;
                this.getInTouch.reset();
                this.formMessage = '';
                $('.form-overlay .overlay').fadeOut();
                $('.ti-close').trigger('click');
              }, 3000);
            }
          });
      }
    }
  }


  /** comment
   * to get categories
   */
  CategoryList() {
    this.cmsService.getFaqCategoryList()
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        this.categories = res.data;
      });
  }

  /** comment
   * to set cookies
   */
  setCookies() {
    this.cookiesService.set('visitor', 'eleven plus', 365);
    this.getCookies();
  }

  /** comment
   * to get cookies
   */
  getCookies() {
    this.cookieValue = this.cookiesService.get('visitor');
  }

  /** comment
   * get current year
   */
  getCurrentYear() {
    const year = new Date();
    return year.getFullYear();
  }

  ngAfterContentInit(): void {

    $(document).ready(() => {
      setInterval(function () {
        $('.cookies-bar').addClass('open');
      }, 30);
      $(window).scroll(function () {
        if ($(this).scrollTop() > 800) {
          $('.gototop')
            .addClass('isvisible')
            .fadeIn(300);

        } else {
          $('.gototop')
            .removeClass('isvisible')
            .fadeOut(300);
        }
      });



      $('.gototop').on('click', () => {
        $('body,html').animate(
          {
            scrollTop: 0
          },
          700
        );
      });


      $(window).scroll(function () {
        if (
          $(window).scrollTop() + $(window).height() >
          $(document).height()
        ) {

          $('.cookies-bar').hide();
        } else {
          $('.cookies-bar').show();
        }
      });

      const width = $(window).width();
      if (width < 900) {
        $('header .open-nav').on('click', () => {
          $('nav').addClass('open');
        });

        $('nav .close-nav').on('click', () => {
          $('nav').removeClass('open');
        });

        $('.close_nav').on('click', () => {
          $('nav').removeClass('open');
        });


        $('.process-wrap .row')
          .addClass('owl-carousel')
          .addClass('owl-theme')
          .addClass('process-wrap-slider');
        const galleryLeft = $('.gallery .col-md-7').html();
        $('.gallery .col-md-7').html($('.gallery .col-md-5').html());
        $('.gallery .col-md-5').html(galleryLeft);
      }

      if ($(window).width() > 900) {
        $('.mega-menu-wrap').hover(
          () => {
            $('.mega-menu').removeClass('remove');
          },
          () => {
            $('.mega-menu').addClass('remove');
          }
        );



        $('.sub-menu-wrap').hover(
          () => {
            $('.submenu').removeClass('remove');
          },
          () => {
            $('.submenu').addClass('remove');
          }
        );



        $('.mega-menu a').on('click', () => {
          $('.mega-menu').addClass('remove');
          $('body,html').animate({
            scrollTop: 0
          }, 10);

        });


        $('.mega-menu li').on('click', () => {
          $('.mega-menu').addClass('remove');
          $('body,html').animate({
            scrollTop: 0
          }, 10);
        });


        $('.submenu-sml *').on('click', () => {
          $('.submenu').addClass('remove');
          $('body,html').animate({
            scrollTop: 0
          }, 10);
        });



        const login = $('.my-acc-drop').attr('data-login');
        if (login === 'has-login') {
          $('header').addClass('has-login');
        }
      }

    });
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}